import {Container, Grid, styled, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import YouTube from 'react-youtube';

const StyledVideo = styled(YouTube)({
  width: '100%',
  borderRadius: 2
});

const youtubeOptions = {width: '100%', height: '323px'};

export default function CustomInstructions({
  instructions,
  instructionsYoutubeId,
  t
}: {
  instructions: string | null;
  instructionsYoutubeId: string | null;
  t: TFunction;
}) {
  return (
    <Container maxWidth="lg">
      <Grid
        container
        direction="row-reverse"
        spacing={4}
        sx={{
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {instructions && (
          <Grid
            size={{
              xs: 12,
              md: instructionsYoutubeId ? 6 : 12
            }}
          >
            <Typography
              dangerouslySetInnerHTML={{
                __html: instructions
              }}
            />
          </Grid>
        )}
        {instructionsYoutubeId && (
          <Grid
            size={{
              xs: 12,
              md: 6
            }}
          >
            <Typography
              align="center"
              variant="h3"
              color="textPrimary"
              sx={{
                mb: '16px'
              }}
            >
              {t('shared/common:diagnosticReport.form.instructions.videoInstructions')}
            </Typography>
            <StyledVideo videoId={instructionsYoutubeId} opts={youtubeOptions} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
